// Application constants

export const APP_NAME = 'IDNGold';
export const APP_VERSION = '1.0.0';

// Network Configuration
export const SUI_NETWORK = {
  MAINNET: 'https://fullnode.mainnet.sui.io',
  TESTNET: 'https://fullnode.testnet.sui.io',
  DEVNET: 'https://fullnode.devnet.sui.io',
};

export const CURRENT_NETWORK = SUI_NETWORK.MAINNET;

// Token Configuration
export const TOKEN_CONFIG = {
  SYMBOL: 'IDNGOLD',
  DECIMALS: 9,
  TOTAL_SUPPLY: 100000000, // 100 million tokens
};

// Presale Configuration
export const PRESALE_CONFIG = {
  MIN_PURCHASE_IDR: 100000, // 100,000 IDR
  MIN_PURCHASE_USDT: 6, // 6 USDT
  TOKEN_PRICE_IDR: 26000, // 26,000 IDR per token
  TOKEN_PRICE_USDT: 1.576, // 1.576 USDT per token
  PHASES: [
    {
      id: 1,
      title: 'Phase 1',
      allocation: 3000000,
      price: 26000,
      status: 'active' as const,
      description: 'Early bird pricing with guaranteed allocation for early investors.',
    },
    {
      id: 2,
      title: 'Phase 2',
      allocation: 3000000,
      price: 28000,
      status: 'coming' as const,
      description: 'Second phase with slightly increased pricing and continued benefits.',
    },
    {
      id: 3,
      title: 'Phase 3',
      allocation: 4000000,
      price: 30000,
      status: 'coming' as const,
      description: 'Final phase with standard pricing before public launch.',
    },
  ],
};

// Wallet Configuration
export const SUPPORTED_WALLETS = [
  {
    name: 'Sui Wallet',
    icon: 'fas fa-wallet',
    version: '1.0.0',
  },
  {
    name: 'Suiet',
    icon: 'fas fa-cube',
    version: '1.0.0',
  },
  {
    name: 'Martian',
    icon: 'fas fa-rocket',
    version: '1.0.0',
  },
  {
    name: 'Ethos',
    icon: 'fas fa-shield-alt',
    version: '1.0.0',
  },
];

// Language Configuration
export const LANGUAGES = [
  {
    code: 'en',
    name: 'English',
    flag: '🇺🇸',
  },
  {
    code: 'id',
    name: 'Indonesia',
    flag: '🇮🇩',
  },
];

// API Configuration
export const API_CONFIG = {
  BASE_URL: 'https://api.idngold.com',
  TIMEOUT: 10000, // 10 seconds
};

// Local Storage Keys
export const STORAGE_KEYS = {
  LANGUAGE: 'idngold_language',
  WALLET: 'idngold_wallet',
  THEME: 'idngold_theme',
};

// Animation Durations
export const ANIMATION_DURATIONS = {
  FAST: 150,
  NORMAL: 250,
  SLOW: 400,
};

// Breakpoints
export const BREAKPOINTS = {
  SM: 640,
  MD: 768,
  LG: 1024,
  XL: 1280,
  '2XL': 1536,
};

// Social Media Links
export const SOCIAL_LINKS = {
  TWITTER: 'https://twitter.com/idngold',
  TELEGRAM: 'https://t.me/idngold',
  DISCORD: 'https://discord.gg/idngold',
  MEDIUM: 'https://medium.com/idngold',
};

// Contact Information
export const CONTACT_INFO = {
  EMAIL: 'support@idngold.com',
  WEBSITE: 'https://idngold.com',
};